export default "__VITE_ASSET__BmZcnMU1__"